import { useFeatureFlag } from '@artic/ui/feature-flags';
import { createFileRoute } from '@tanstack/react-router';

import { CauseCategoriesView } from '../../features/cause-categories/cause-categories-view';
import { usePartnerId } from '../../features/inbox/use-partner-name';

export const Route = createFileRoute('/cause_categories/')({
  component: CauseCategoriesPage,
});

function CauseCategoriesPage() {
  const enabled = useFeatureFlag('causes');
  const partnerId = usePartnerId();

  if (!enabled) {
    return (
      <div className="flex flex-col items-center justify-center gap-2 py-20">
        <h2 className="text-lg font-semibold">Feature not available</h2>
        <p className="text-muted-foreground text-sm">
          Cause category management in Quality is not enabled for your organisation.
        </p>
      </div>
    );
  }

  return <CauseCategoriesView partnerId={partnerId} />;
}
